import { useMemo } from 'react';

import { useGetNylasConnectionStatusQuery, useGetSchedulerConfigQuery } from '../api';
import { isCalendarValid } from './is-calendar-valid';

export const useHasCalendarConfiguration = () => {
  const { data: schedulerConfig } = useGetSchedulerConfigQuery();
  const { data: nylasConnectionStatus } = useGetNylasConnectionStatusQuery();

  const isCalendarValidStatus = isCalendarValid(nylasConnectionStatus);

  return useMemo(() => {
    if (!schedulerConfig || !isCalendarValidStatus) return false;
    return Object.values(schedulerConfig).some((config) => config.duration > 0);
  }, [schedulerConfig, isCalendarValidStatus]);
};
